import * as API from "./crud";
import {slice, defaultEntity, actionTypes} from "./slice";

const {actions} = slice;


export const fetchNotifications = (meta, type = actionTypes.List) => dispatch => {
  dispatch(actions.startCall({type}));
  return API
      .getAll(meta)
      .then(({data:{entities, meta}, status}) => {
        dispatch(actions.fetched({entities, meta, type}));

        // return {status};
      })
      .catch(({response:{data, status}}) => {
        dispatch(actions.catchError({ data, type}));
        return {status};
      });
};


export const readNotification = (id, metadata, type) => dispatch => {
  if (!id) {
    return dispatch(actions.fetched({ entity: defaultEntity, type }));
  }

  dispatch(actions.startCall({type}));
  return API
    .read(id, metadata)
    .then(({data:entity, status}) => {
      dispatch(actions.fetched({ entity, type}));
      return {status};
    })
    .catch(({response:{data, status}}) => {
      dispatch(actions.catchError({ data,  type}));
      return {status};
    });
};




export const deleteEntity = (id, type = actionTypes.Delete) => dispatch => {
  dispatch(actions.startCall({type}));
  return API
    .deleteEntity(id)
    .then(({status}) => {
      dispatch(actions.endCall({ type }));
      return {status};
    })
    .catch(({response:{data,status}}) => {
      dispatch(actions.catchError({ data, type}));
      return {status};
    });
};

export const updateEntity = (entity, type = actionTypes.Edit) => dispatch => {
  dispatch(actions.startCall({type}));
  return API
    .update(entity)
    .then(({data:entity, status}) => {
      dispatch(actions.endCall({ entity, type }));
      return {status};
    })
    .catch(({response:{data, status}}) => {
      dispatch(actions.catchError({ data, type}));
      return {status};
    });
};




// export const commented = (comment, type = actionTypes.Edit) => dispatch => {
//   dispatch(actions.endCall({ entity, type }));
// };
